angular.module("app").factory('Banner2Service', function($resource, apiUrl, resourceInterceptor) {
    return $resource(apiUrl + "/banner2/:id", { id: "@id" }, {
        search: {
            method: "GET",
            interceptor: resourceInterceptor
        },
        get: {
            method: "GET",
            interceptor: resourceInterceptor
        },
        save: {
            method: "PUT",
            headers: { 'Content-Type': undefined },
            transformRequest: angular.identity,
            interceptor: resourceInterceptor
        }
    });

})
